import { render, staticRenderFns } from "./TargetContribution.vue?vue&type=template&id=765af3a3"
import script from "./TargetContribution.vue?vue&type=script&lang=js"
export * from "./TargetContribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports